import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignInSide from './pages/login/login';
import OlvidoContrasenaPage from './pages/login/olvidoContrasena';
import RestablecerContrasenaPage from './pages/login/restablecerContrasena';
import Usuarios from './pages/usuarios/usuarios';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import PaginaPrincipal from "./pages/PaginaPrincipal/PaginaPrincipal";
import ProyectosPage from './pages/Proyectos/proyectos';
import GestionProyectoPage from './pages/Proyectos/gestionProyecto';
import CrearProyectoPage from './pages/Proyectos/crearProyecto';
import CrearProyectoPublicoPage from './pages/Proyectos/crearProyectoPublico';
import AccesoProyectosPublicoPage from './pages/Proyectos/accesoProyectosPublico';
import CorreccionSolicitudPublicaPage from './pages/Proyectos/correccionSolicitudPublica';
import EstadoProyectoPublicoPage from './pages/Proyectos/estadoProyectoPublico';
import PermisosProyectosPage from './pages/Proyectos/permisosProyectos';
import RedisennoAprobacionesPage from './pages/Proyectos/redisennoAprobaciones';
import CartaRemisoriaJefeAprobacionesPage from './pages/Proyectos/cartaRemisoriaJefeAprobaciones';
import CalculoBurdenPage from './pages/Proyectos/calculoBurden';
import PruebaCorreoPage from './pages/Proyectos/pruebaCorreo';
import AdminProyectosRoute from './components/PrivateRoute/AdminProyectosRoute';
import JefeProyectosRoute from './components/PrivateRoute/JefeProyectosRoute';
import AsignacionDisenadorPage from './pages/Proyectos/asignacionDisenador';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
          <Route path="/" element={<SignInSide />} />
          <Route path="/olvido-contrasena" element={<OlvidoContrasenaPage />} />
          <Route path="/restablecer-clave" element={<RestablecerContrasenaPage />} />
          <Route path="/proyectos/crear" element={<AccesoProyectosPublicoPage />} />
          <Route path="/proyectos/crear/solicitud" element={<CrearProyectoPublicoPage />} />
          <Route path="/proyectos/crear/correccion" element={<CorreccionSolicitudPublicaPage />} />
          <Route path="/proyectos/crear/estado" element={<EstadoProyectoPublicoPage />} />
          <Route path="/dashboard" element={<PrivateRoute element={<PaginaPrincipal  />} />} />
          <Route path="/proyectos-panel" element={<PrivateRoute element={<ProyectosPage />} />} />
          <Route path="/proyectos-panel/nuevo" element={<PrivateRoute element={<CrearProyectoPage />} />} />
          <Route path="/proyectos-panel/:id/gestion" element={<PrivateRoute element={<GestionProyectoPage />} />} />
          <Route path="/usuarios" element={<PrivateRoute element={<Usuarios />} />} />
          <Route path="/calculo-burden" element={<PrivateRoute element={<CalculoBurdenPage />} />} />
          <Route path="/prueba-correo" element={<PrivateRoute element={<PruebaCorreoPage />} />} />
          <Route
            path="/proyectos-permisos"
            element={<AdminProyectosRoute element={<PermisosProyectosPage />} />}
          />
          <Route
            path="/proyectos-asignacion-disenador"
            element={<JefeProyectosRoute element={<AsignacionDisenadorPage />} />}
          />
          <Route
            path="/proyectos-redisenno"
            element={<JefeProyectosRoute element={<RedisennoAprobacionesPage />} />}
          />
          <Route
            path="/proyectos-asignacion-interventor"
            element={<JefeProyectosRoute element={<CartaRemisoriaJefeAprobacionesPage />} />}
          />
          <Route
            path="/proyectos-aprobaciones-jefe"
            element={<Navigate to="/proyectos-asignacion-interventor" replace />}
          />
        <Route path="*" element={<SignInSide />} />
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
